import { NEXT_AUTH_METHOD } from '@app/constants/auth';
import { AbstractHttp, ServiceMethod } from '@app/libs/services';
import { apiConfig } from '@app/repositories/config';

export class AuthService extends AbstractHttp {
  protected services = {
    login: {
      uri: 'auth/login',
      method: 'POST' as ServiceMethod,
      host: '/',
      prefix: 'api',
      version: 'v1',
      params: {
        email: { required: true },
        password: { required: true },
      },
      headers: {
        'Content-Type': 'application/json',
      },
    },
    logout: {
      uri: 'auth/logout',
      method: 'POST' as ServiceMethod,
      host: '/',
      prefix: 'api',
      version: 'v1',
      authRequire: 'optional' as const,
    },
    otp: {
      uri: 'auth/otp',
      method: 'POST' as ServiceMethod,
      host: '/',
      prefix: 'api',
      version: 'v1',
      params: {
        [NEXT_AUTH_METHOD]: { required: true },
      },
      headers: {
        'Content-Type': 'application/json',
      },
    },
    'reset-password': {
      uri: 'auth/reset-password',
      method: 'POST' as ServiceMethod,
      host: '/',
      prefix: 'api',
      version: 'v1',
      params: {
        [NEXT_AUTH_METHOD]: { required: true },
      },
      headers: {
        'Content-Type': 'application/json',
      },
    },
    register: {
      uri: 'auth/register',
      method: 'POST' as ServiceMethod,
      host: '/',
      prefix: 'api',
      version: 'v1',
      params: {
        [NEXT_AUTH_METHOD]: { required: true },
        password: { required: true },
        otp: { required: true },
      },
      headers: {
        'Content-Type': 'application/json',
      },
    },
    'set-password': {
      uri: 'auth/set-password',
      method: 'POST' as ServiceMethod,
      host: '/',
      prefix: 'api',
      version: 'v1',
      params: {
        [NEXT_AUTH_METHOD]: { required: true },
        password: { required: true },
        otp: { required: true },
      },
      headers: {
        'Content-Type': 'application/json',
      },
    },
    'change-password': {
      uri: 'auth/change-password',
      method: 'POST' as ServiceMethod,
      host: '/',
      prefix: 'api',
      version: 'v1',
      params: {
        oldPassword: { required: true },
        newPassword: { required: true },
      },
      headers: {
        'Content-Type': 'application/json',
      },
    },
  };

  login(email: string, password: string) {
    return this.send('login', { params: { [NEXT_AUTH_METHOD]: email, password } });
  }

  otp(email: string) {
    return this.send('otp', { params: { [NEXT_AUTH_METHOD]: email } });
  }

  changePassword(oldPassword: string, password: string) {
    return this.send('change-password', { params: { oldPassword, newPassword: password } });
  }

  setPassword(email: string, password: string, otp: string) {
    return this.send('set-password', { params: { [NEXT_AUTH_METHOD]: email, password, otp } });
  }

  register(email: string, password: string, otp: string) {
    return this.send('register', { params: { [NEXT_AUTH_METHOD]: email, password, otp } });
  }

  logout() {
    return this.send('logout', {});
  }
}

export const authService = new AuthService();
